import request from "@/utils/request";

// 首页专家列表
export function listForProfessor(params) {
  return request({
    url: "/expertInfo/listForIndex",
    method: "get",
    params,
  });
}
// 内页专家列表
export function listForProfessorTwo(params) {
  return request({
    url: "/expertInfo/list",
    method: "get",
    params,
  });
}
// 专家访谈列表
export function listInterviewList(params) {
  return request({
    url: "/expertInfo/interviewList",
    method: "get",
    params,
  });
}
// 专家详情
export function infopeopledetail(params) {
  return request({
    url: "/expertInfo/detail",
    method: "get",
    params,
  });
}
// 专家列表文章详情
export function infonewsdetail(params) {
  return request({
    url: "/expertInfo/interviewDetail",
    method: "get",
    params,
  });
}
// 新闻列表
export function newsList(params) {
  return request({
    url: "/newsInfo/listForIndex",
    method: "get",
    params,
  });
}
// 新闻资讯列表
export function newsInfoList(params) {
  return request({
    url: "/newsInfo/list",
    method: "get",
    params,
  });
}
// 新闻资讯详情
export function newsInfoDetail(params) {
  return request({
    url: "/newsInfo/detail",
    method: "get",
    params,
  });
}

// 最新交易所数据
export function tradeLatest(params) {
  return request({
    url: "/tradeCenter/latest",
    method: "get",
    params,
  });
}

// 交易中心数据图表(日均价、成交量、成交价格)
export function tradeChart(params) {
  return request({
    url: "/tradeCenter/chart",
    method: "get",
    params,
  });
}
// 交易中心数据图表(周均价、成交量、成交价格)
export function tradeChartWeek(params) {
  return request({
    url: "/tradeCenter/weekChart",
    method: "get",
    params,
  });
}
// 交易中心数据图表(月均价、成交量、成交价格)
export function tradeChartMonth(params) {
  return request({
    url: "/tradeCenter/monthChart",
    method: "get",
    params,
  });
}
// 近一年/近半年/近三月/近一月/近一周/近一日数据
export function tradeRecentAverage(params) {
  return request({
    url: "/tradeCenter/recentRangeAveragePrices",
    method: "get",
    params,
  });
}
// 交易中心数据图表-包含类型和地区
export function tradeChartType(params) {
  return request({
    url: "/tradeCenter/chartWithType",
    method: "get",
    params,
  });
}
// 全国市场行情
export function tradeMarket(params) {
  return request({
    url: "/tradeCenter/nationalMarketSituation",
    method: "get",
    params,
  });
}
// 绿证行情
export function tradeLvzheng(params) {
  return request({
    url: "/tradeCenter/greenCertificate",
    method: "get",
    params,
  });
}
// 重庆行情
export function tradeChongqing(params) {
  return request({
    url: "/tradeCenter/cqMarketSituation",
    method: "get",
    params,
  });
}
//福建市场行情
export function tradeFujian(params) {
  return request({
    url: "/tradeCenter/fjMarketSituation",
    method: "get",
    params,
  });
}
// 广东市场行情
export function tradeGuangdong(params) {
  return request({
    url: "/tradeCenter/gdMarketSituation",
    method: "get",
    params,
  });
}

// 湖北市场行情
export function tradeHubei(params) {
  return request({
    url: "/tradeCenter/hbMarketSituation",
    method: "get",
    params,
  });
}

// 上海市场行情
export function tradeShanghai(params) {
  return request({
    url: "/tradeCenter/shMarketSituation",
    method: "get",
    params,
  });
}
// 深圳市场行情
export function tradeShengzhen(params) {
  return request({
    url: "/tradeCenter/szMarketSituation",
    method: "get",
    params,
  });
}

// 首页视频分享列表
export function videoList(params) {
  return request({
    url: "/video/listForIndex",
    method: "get",
    params,
  });
}
// 建议和策略
export function suggestList(params) {
  return request({
    url: "/check/suggestionStrategy/list",
    method: "get",
    params,
  });
}
// 月报筛选
export function monthReportOption(params) {
  return request({
    url: "/check/monthReport/option",
    method: "get",
    params,
  });
}
// 月报概览
export function monthReportDetail(params) {
  return request({
    url: "/check/monthReport/detail",
    method: "get",
    params,
  });
}
// 首页-求购-售卖列表
export function tradeList(params) {
  return request({
    url: "/listingInfo/listForIndex",
    method: "get",
    params,
  });
}
// 求购列表页
export function tradeMoreList(params) {
  return request({
    url: "/listingInfo/list",
    method: "get",
    params,
  });
}

// 挂牌信息详情
export function tradeListDetail(params) {
  return request({
    url: "/listingInfo/detail",
    method: "get",
    params,
  });
}
//分析报告-价格信息
export function analysisReportPrice(params) {
  return request({
    url: "/check/tradeCenter/analysisReportPrice",
    method: "get",
    params,
  });
}

//分析报告-近期价格波动
export function recentPrice(params) {
  return request({
    url: "/check/tradeCenter/recentPrice",
    method: "get",
    params,
  });
}

// 首页-成交情况
export function dealList(params) {
  return request({
    url: "/order/dealInfo",
    method: "get",
    params,
  });
}
// 首页-成交情况修改
export function dealListChange(params) {
  return request({
    url: "/tradeCenter/recentVolumeStats",
    method: "get",
    params,
  });
}

// 成交情况-热点分析
export function hotSpots(params) {
  return request({
    url: "/check/tradeCenter/hotSpots",
    method: "get",
    params,
  });
}
// 政策列表
export function policyList(params) {
  return request({
    url: "/check/policyRegulation/list",
    method: "get",
    params,
  });
}
// 分析报告-价格散点图
export function priceScatterChart(params) {
  return request({
    url: "/check/listingInfo/priceScatterChart",
    method: "get",
    params,
  });
}
// 月报-市场概览
export function monthReport(params) {
  return request({
    url: "/check/tradeCenter/monthReport",
    method: "get",
    params,
  });
}

// 获取订单ID
export function tradeGetOrderId(params) {
  return request({
    url: "/check/order/getOrderId",
    method: "get",
    params,
  });
}
// 确定下单-订单创建
export function orderCreate(data) {
  return request({
    url: "/check/order/create",
    method: "post",
    data,
  });
}

// 立即报价
export function quotationSave(data) {
  return request({
    url: "/check/quotation/save",
    method: "post",
    data,
  });
}
// 报价详情
export function tradebaojiaDetail(params) {
  return request({
    url: "/check/quotation/detail",
    method: "get",
    params,
  });
}

// 加入收藏
export function addFavorite(data) {
  return request({
    url: "/check/listingFavorite/add",
    method: "post",
    data,
  });
}
// 取消收藏
export function removeFavorite(data) {
  return request({
    url: "/check/listingFavorite/remove",
    method: "post",
    data,
  });
}

// 收藏列表
export function favoriteList(params) {
  return request({
    url: "/check/listingFavorite/list",
    method: "get",
    params,
  });
}

// 造林年份
export function afforestationYear(params) {
  return request({
    url: "/projectEvaluationCalculation/treeYear",
    method: "get",
    params,
  });
}
// 造林树种
export function afforestationTree(params) {
  return request({
    url: "/projectEvaluationCalculation/treeType",
    method: "get",
    params,
  });
}
// 项目评估计算
export function projectEvaluationCalculation(data) {
  return request({
    url: "/projectEvaluationCalculation/calculate",
    method: "post",
    data,
  });
}
// 项目评估计算-低浓度瓦斯
export function projectEvaluationCalculationLow(data) {
  return request({
    url: "/projectEvaluationCalculation/gasCalculate",
    method: "post",
    data,
  });
}
// 项目咨询-我找资金
export function greenFinanceDemand(data) {
  return request({
    url: "/greenFinanceDemand/save",
    method: "post",
    data,
  });
}
